// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6205":"056ecd12","7020":"c7d4449d","8120":"e872979c"}[chunkId] + ".chunk.css";
};